import styled from "@emotion/styled"
import { spacingStaticSm, spacingStaticMd, spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import { ContentWrapper, Flex, Skeleton } from "src/components"

export const HeaderSkeleton = () => (
	<StyledContentWrapper>
		<Skeleton.Heading size="2xl" $width="35%" />
		<Flex $wrap="wrap" $gap="xs">
			<Skeleton.Tag $width="80px" />
			<Skeleton.Tag $width="180px" />
			{Array.from({ length: 4 }, (_, i) => (
				<Skeleton.Tag key={i} $width="60px" />
			))}
		</Flex>
	</StyledContentWrapper>
)

const StyledContentWrapper = styled(ContentWrapper)`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
	padding-top: ${spacingStaticMd};
	padding-bottom: ${spacingStaticLg};
`
